import { render } from "./SearchDialog.vue?vue&type=template&id=ffef7f42&scoped=true"
import script from "./SearchDialog.vue?vue&type=script&lang=js"
export * from "./SearchDialog.vue?vue&type=script&lang=js"

import "./SearchDialog.vue?vue&type=style&index=0&id=ffef7f42&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ffef7f42"]])

export default __exports__